import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface PictorialBarChartProps {
  categories: string[];
  series: Array<{ name: string; data: number[] }>;
  symbol?: string;
  height?: number | string;
  loading?: boolean;
}

export function PictorialBarChart({ categories, series, symbol = 'circle', height, loading }: PictorialBarChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'axis' },
    legend: { bottom: 0 },
    grid: { left: 50, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: { type: 'category', data: categories },
    yAxis: { type: 'value' },
    series: series.map((s) => ({
      name: s.name,
      type: 'pictorialBar',
      data: s.data,
      symbol,
      symbolRepeat: true,
      symbolSize: [12, 4],
      symbolOffset: [0, 0],
      symbolMargin: 2,
      itemStyle: { opacity: 0.8 },
    })),
  };
  return <EChart option={option} height={height} loading={loading} />;
}
